import { Input } from "@legal-500/legal500-design-system";
import type { FieldValues, Path, UseFormRegister } from "react-hook-form";
import type { BlockContentErrors } from "./types";
import styles from "../CMS.module.css";

type ButtonFieldsProps<T extends FieldValues> = {
  register: UseFormRegister<T>;
  name: string;
  idPrefix: string;
  legend: string;
  errors: BlockContentErrors;
};

export function ButtonFields<T extends FieldValues>({
  register,
  name,
  idPrefix,
  legend,
  errors,
}: ButtonFieldsProps<T>) {
  return (
    <fieldset className={styles.fieldset}>
      <legend className={styles.fieldsetLegend}>{legend}</legend>

      <div className={styles.formField}>
        <label className={styles.formLabel} htmlFor={`${idPrefix}-label`}>
          Label
        </label>
        <Input
          id={`${idPrefix}-label`}
          error={errors[`${name}.label`]}
          {...register(`${name}.label` as Path<T>)}
        />
      </div>

      <div className={styles.formField}>
        <label className={styles.formLabel} htmlFor={`${idPrefix}-href`}>
          Link
        </label>
        <Input
          id={`${idPrefix}-href`}
          placeholder="https://…, /path, #anchor, mailto:… or tel:…"
          error={errors[`${name}.href`]}
          {...register(`${name}.href` as Path<T>)}
        />
      </div>

      <div className={styles.formField}>
        <label className={styles.formLabel} htmlFor={`${idPrefix}-variant`}>
          Variant
        </label>
        <select
          id={`${idPrefix}-variant`}
          className={styles.selectField}
          {...register(`${name}.variant` as Path<T>)}
        >
          <option value="primary">Primary</option>
          <option value="secondary">Secondary</option>
        </select>
      </div>
    </fieldset>
  );
}
